import React from "react";
import Link from "gatsby-link";
import Imgix from "react-imgix";
import cx from "classnames";
import Icon from "./Icon";

const MapBar = ({ hide }) => {
  return (
    <Link
      to="/live-downtown/virtual-tour/"
      className={cx("map-bar flex z-1 relative", { "display-none": hide })}
    >
      <div className="map-bar__container bg-gold dn db-l h-100 w-100 relative overflow-hidden">
        <Imgix
          src={require("../../assets/images/map-bg.gif")}
          className="map-bar__image absolute left-0 bg-center cover"
          htmlAttributes={{
            alt: "Map of Downtown Richmond"
          }}
        />
      </div>
      <div className="map-bar__info bg-green bg-ease-out h-100 w-100 justify-between items-center flex">
        <div className="h-100 flex items-center">
          <p className="h-5 ttu mb0 nowrap dark">Downtown Map</p>
          <Icon
            path="icon-18-food-and-drink"
            height="17"
            width="17"
            className="ml1"
          />
          <Icon path="icon-18-venue" height="17" width="17" className="ml1" />
          <Icon path="icon-26-parking" height="17" width="17" className="ml1" />
        </div>
        <Icon
          path="arrow-accessory-right"
          height="12"
          width="8"
          className="ml2"
        />
      </div>
    </Link>
  );
};

export default MapBar;



// WEBPACK FOOTER //
// ./src/components/MapBar.js